<div class="px-3 md:px-10 xl:px-[175px]" [ngClass]="{'hidden': !bandoDetails.title }">

  <script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": "https://innovationplaza.it/cerca-bando/#webpage",
      "url": "https://innovationplaza.it/cerca-bando/",
      "name": "Bandi e Opportunita' di Finanziamento — Innovation Plaza",
      "description": "Bandi, call e programmi di finanziamento europei, nazionali e regionali per imprese, startup e istituzioni. Horizon Europe, FESR, FSE, MISE, PAC e programmi operativi regionali.",
      "inLanguage": "it-IT",
      "isPartOf": {
        "@id": "https://innovationplaza.it/#website"
      },
      "about": {
        "@type": "Thing",
        "name": "Finanziamenti e Bandi pubblici per l'innovazione"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://innovationplaza.it/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Bandi",
            "item": "https://innovationplaza.it/bandi/"
          }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "Programmi di Finanziamento gestiti da Innovation Plaza",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Horizon Europe"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Digital Europe Programme"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Cooperazione Territoriale Europea (CTE)"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "Creative Europe"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "Bandi MISE per R&S"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "Programmi Operativi Regionali FESR-FSE-FC"
          },
          {
            "@type": "ListItem",
            "position": 7,
            "name": "Politica Agricola Comune (PAC)"
          }
        ]
      }
    },
    {
      "@type": "Service",
      "@id": "https://innovationplaza.it/cerca-bando/#service",
      "name": "Consulenza Strategica e Direzionale per l'Innovazione",
      "serviceType": "Consulenza di direzione e strategia",
      "description": "Supporto a imprese e istituzioni nei processi di analisi, strategia, marketing e ideazione. Gestione di iniziative complesse di sviluppo locale, territoriale e internazionale.",
      "url": "https://innovationplaza.it/cerca-bando/",
      "provider": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Italia"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Imprese, istituzioni, aspiranti imprenditori"
      }
    }
  ]
}
</script>
@if(bandoDetails.id && showModalManulVerification && (user.role == 7 || user.role == 5)){
<app-page-notice-verification-admin-component (close)="showModalManulVerification = false" [fatherElement]="bandoDetails"></app-page-notice-verification-admin-component>}
  <div class="aspect43:flex aspect43:place-content-between">
    <div class="mb-20 w-full">
      <div (click)="goBack()" class="text-quaternary text-font30px cursor-pointer gap-2.5 items-center flex">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.4385 18.75L4.68848 12L11.4385 5.25" stroke="#1F299C" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="square" />
          <path d="M5.625 11.9995L19.3125 11.9995" stroke="#1F299C" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="square" />
        </svg>

        <span>Torna indietro</span>
      </div>
      @if(user?.role == 5){
      <div (click)="goBandoDetails(bandoDetails.id)"
        class="text-white cursor-pointer my-4 font-normal px-[24px] h-[30px] rounded-full bg-[#719CFF] flex items-center text-font20px w-fit justify-center">
        Modifica bando</div>}
      <div class="md:flex gap-5 mt-10" style="text-align: -webkit-center;">
        <div>
          <div class="font-bold text-[#283759] text-font20px">Stato</div>
          <div
            class="text-white font-normal px-[24px] h-[30px] rounded-full bg-[#719CFF] flex items-center text-font20px w-fit justify-center">

            <div>{{bandoDetails.statusDesc}}</div>
          </div>
        </div>
        <div class="text-quaternary text-font18px">
          <div class="text-font20px font-bold text-[#283759]">Inizio
          </div>
          <div class="text-[#364349] text-font20px font-normal">{{bandoDetails.startDate == '1/1/1970' ?'Da stabilire'
            :bandoDetails.startDate}}</div>
        </div>
        <div class="text-quaternary text-font18px">
          <div class="text-font20px font-bold text-[#283759]">Scadenza
          </div>
          <div class="text-[#364349] text-font20px font-normal">{{bandoDetails.endDate == '1/1/1970' ?'Fino ad esaurimento fondi' :bandoDetails.endDate}}</div>
        </div>
        <div class="">
          <div class="text-font20px font-bold text-[#283759]">Dotazione Complessiva
          </div>
          <div class="text-[#364349] text-font20px font-normal">{{bandoDetails.stanziamentoIncentivo ? '€' +
            bandoDetails.stanziamentoIncentivo : 'Fino a esaurimento fondi'}}</div>
        </div>
      </div>
      <div class="text-font32px leading-[34px] font-semibold text-[#283759] mt-10">
        {{bandoDetails.title}}
      </div>



      <div class="text-font24px font-bold mt-5 text-[#719CFF]">{{bandoDetails.soggettoConcedente}}</div>

      <div class="flex flex-wrap gap-2 mt-6">
        @for (label of bandoDetails.labels; track $index) {
        <div
          class="px-[16px] border-[#719CFF] border-[1px] rounded-full text-font14px h-[26px] bg-white text-[#719CFF] font-medium flex items-center place-content-center">
          {{label}}</div>
        }
      </div>

      @if(bandoDetails.formaAgevolazione){<div id="card-price"
        style="box-shadow: 2px 4px 12px 2px rgba(0, 89, 255, 0.04);"
        class="w-full mt-[60px] rounded-[20px] bg-Swhite p-5 md:py-[30px] md:px-[56px] border-[2px] border-[#D3E0FF]">
        <div class="sm:flex items-center place-content-between">
          <div class="min-h-[59px] text-[#283759] font-bold text-font20px">Caratteristiche Bando</div>
          <div class="min-h-[59px]"> @for (agevolazione of bandoDetails.formaAgevolazione.split(','); track $index) {
            <div class="text-[#364349] text-font18px leading-[23px] font-semibold">
              {{agevolazione}}</div>}
          </div>
          <div class="">
            <div (click)="(user.role == 7 || user.role == 5) ? showModalManulVerification = true :goTo()"
              class="rounded-full h-[48px] bg-quintary px-[32px] flex items-center place-content-center text-font14px aspect43:text-font24px text-white cursor-pointer">
              Verifica ammissibilità</div>

          </div>
        </div>

      </div>}

      <div class="flex w-full">
        <div class="w-full">
          <div class="md:flex place-content-between w-full">
          <div class="mt-2.5 font-normal underline cursor-pointer text-font24px text-quaternary"><a
              [href]="bandoDetails.linkIstituzionale" target="_blank">Link istituzionale</a></div>
          @if(user.role == 7 || user.role == 5){<div (click)="downloadBando()" class="mt-2.5 font-normal underline cursor-pointer text-font24px text-quaternary">Scarica bando</div>}
        </div>
          <div class="text-quaternary mt-2.5 w-full text-font24px"><span class="text-font24px font-bold text-[#283759]">
              Finalità: </span>
            <div class="text-[#364349] text-font20px leading-[26px] font-normal">{{bandoDetails.obiettivoFinalita}}
            </div>
          </div>


        </div>
      </div>
      @if(bandoDetails.desc1 != null) {
      <div class="text-quaternary mt-[40px] w-full text-font24px"><span
          class="text-font24px font-bold text-[#283759]">Descrizione: </span>
        <div class="text-[#364349] text-font20px leading-[26px] font-normal text-justify" style="white-space: pre-line">
          {{bandoDetails.desc1}}</div>
      </div>
      <div class="text-quaternary mt-[40px] w-full text-font24px"><span class="text-font24px font-bold text-[#283759]">A
          chi si rivolge: </span>
        <div class="text-[#364349] text-font20px leading-[26px] font-normal text-justify" style="white-space: pre-line">
          {{bandoDetails.desc2}}</div>
      </div>
      <div class="text-quaternary mt-[40px] w-full text-font24px"><span
          class="text-font24px font-bold text-[#283759]">Cosa prevede: </span>
        <div class="text-[#364349] text-font20px leading-[26px] font-normal text-justify" style="white-space: pre-line">
          {{bandoDetails.desc3}}</div>
      </div>
      } @else {
      <div class="text-quaternary mt-[40px] w-full text-font24px"><span
          class="text-font24px font-bold text-[#283759]">Descrizione: </span>
        <div class="text-[#364349] text-font20px leading-[26px] font-normal text-justify" style="white-space: pre-line">
          {{bandoDetails.description}}</div>
      </div>
      }
      <div class="flex flex-wrap gap-2.5 select-none">
        @for (category of categories; track $index) {
        <div
          class="text-quaternary bg-white text-font14px aspect43:text-font18px leading-[var(--18px)] rounded-full p-[14px] aspect43:px-[20px] aspect43:py-[18px] cursor-pointer"
          (click)="indexSelected == $index?indexSelected = -1: indexSelected = $index"
          [ngClass]="{'!bg-quaternary !text-Swhite': indexSelected ==  $index}"
          style="border:1px solid var(--quaternary) !important">{{category.category.name}}</div>
        }

      </div>
      <div class="aspect43:flex items-center mt-10 aspect43:mt-4 gap-[100px]">

        <div class="text-font19px aspect43:text-font26px text-quaternary aspect43:w-[calc(100%-550px)]">

          <!-- <div><span class="font-bold">Cos'è: </span>{{bandoDetails.desc1}}<br><br>
                
            </div> -->

        </div>

      </div>
      @if(modalVerification){
      <div (scroll)="$event.preventDefault()"
        class="fixed top-0 left-0  !w-screen h-[5000px] flex place-content-center bg-black bg-opacity-35">
        <div (click)="$event.stopPropagation()"
          class="min-w-[300px] h-fit mt-[300px] max-w-[400px] bg-white rounded-[20px] shadow-xl p-[25px]">
          <div class="w-[20px] ml-auto cursor-pointer" (click)="modalVerification = false"><svg class="w-5 h-5"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
              <path fill="black"
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg></div>
          <div class="font-kansas text-font24px font-semibold text-quaternary overflow-hidden text-ellipsis">
            @if(accepted){Sei ammissibile per questo bando, clicca su partecipa per unirti al
            progetto}@if(!accepted && motivation){
            {{motivation}}}
            @if(!accepted && !motivation){
            Non sei ammissibile per questo bando, clicca su contattaci per contattarci}
          </div>
          <div class="text-[14px]">Motivo:{{reasoning}}</div>
          <div class="text-[11px]">Questa analisi preliminare è stata generata dal nostro sistema di intelligenza
            artificiale
            per offrirti un primo orientamento. Poiché non sostituisce un parere professionale, ti suggeriamo di
            confrontarti con
            un nostro consulente esperto per ottimizzare e valorizzare al meglio la tua candidatura</div>
          @if(accepted){<div (click)="join(bandoDetails.id)" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);"
            class="w-[165px] ml-auto font-medium h-[43px] rounded-full bg-primary text-font18px cursor-pointer text-Swhite flex items-center place-content-center mt-10">
            Partecipa</div>}
          @if(!accepted){<div (click)="goToContact()" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);"
            class="w-[165px] ml-auto font-medium h-[43px] rounded-full bg-primary text-font18px cursor-pointer text-Swhite flex items-center place-content-center mt-10">
            Contattaci</div>}
        </div>
      </div>
      }
      <div (click)="goBack()" class="text-quaternary text-font30px cursor-pointer gap-2.5 pt-16 items-center flex">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.4385 18.75L4.68848 12L11.4385 5.25" stroke="#1F299C" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="square" />
          <path d="M5.625 11.9995L19.3125 11.9995" stroke="#1F299C" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="square" />
        </svg>

        <span>Torna indietro</span>
      </div>
    </div>

  </div>
</div>